module.exports = __webpack_public_path__ + "static/img/login_bg.80c3eb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/chaoxinxing/login_bg.jpg
// module id = 934
// module chunks = 30